<div class="box-container">
  @if (showRemove) {
    <button class="close-button icon icon-close-x" (click)="onRemove.emit()"></button>
  }
  <div class="relative">
    <targeting-label class="margin-bottom--4px display--block" [label]="targetingLabel"></targeting-label>
    <h3 e2e-id="estimated-views" class="box-header margin-top--2x margin-bottom--1x">
      <span class="value">{{ estimatedViews | number | dashAsDefault }}</span>
      <span e2e-id="view-currency" class="currency padding-left--1x">{{currency}}</span>
    </h3>

    <div class="divider dark margin-top--1x margin-bottom--2x"></div>
    @for(row of targetingRows.concat(estimationRows); track $index) {
      <p class="targeting-row margin-bottom--4px">
        <span class="text-align--left">{{row.label}}</span>
        <span class="text-align--right">{{row.value | dashAsDefault}}</span>
      </p>
    }

    @if (includesLinear) {
      <regional-indicator title="Regionalpaketering" [subtitle]="salesOrderNumber"></regional-indicator>
    }
    @if (isRegional && regionalDivision === RegionalDivision.ZipCodeBased) {
      <regional-indicator title="Postnummerstyrning" ></regional-indicator>
    }
    <send-invoices-indicator [sendInvoices]="sendInvoices"></send-invoices-indicator>

    @if (forcedCorrection?.unbookableWeeks?.length) {
      <p>
        <span class="text-align--left">Fulla veckor: </span>
        <span class="text-align--right" class="text--danger">{{unbookableWeeks | dashAsDefault}}</span>
      </p>
    }
    @if (showEditTargeting) {
      <edit-button (click)="onEditTargeting.emit()"></edit-button>
    }
  </div>
  @if (creativesRows.length > 0) {
  <div class="relative">
    <div class="divider dark margin-top-bottom--1x"></div>
    @for(row of creativesRows; track $index) {
      <p class="margin-bottom--4px ellipsis">
        {{row}}
      </p>
    }

    @if (showEditCreatives) {
      <edit-button (click)="onEditCreatives.emit()"></edit-button>
    }
  </div>
  }
</div>
